export default {
  left: {
    group: '我的分组',
    location: '日程地点',
    description: '日程说明',
    scoreChart: '评分表',
    scoreChartDescription: '评分表说明',
  },
  logout: '退出登录',
  right: {
    title: '面试官打分结果确认表',
    project: '项目',
    scheduleDate: '面试日期',
    scoreChart: '面试评分表',
    interviewer: '面试官',
    name: '面试名称',
    placeholder: '全部安排',
  },
  footer: {
    tip: '请确认以上评分及评语无误，确认签字后，将不可修改。',
    signature: '面试官签字',
    date: '日期',
    signatureButton: '请点击此处进行签字',
    signatureDraw: '请在此区域签字',
    signatureConfirm: '请核对签名后进行提交，提交后不可更改。',
    buttonConfirm: '确认提交',
    buttonClear: '清空',
    success: '感谢您完成任务',
    confirm: '确定',
  },
  titleShow: '面试官打分结果确认表',
  signOutConfirm: '确定退出面试评分系统？',
  signOutCancel: '取消退出',
  error401: '登录过期，请重新登录',
};
